import { getRequestProfileBase } from '../../../api'
import {
  HTTP_STATUS_INTERNAL_SERVER_ERROR,
  HTTP_STATUS_NOT_FOUND,
} from '../../../constants/api'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../constants/pagination'
import { PAGE_SIZE_PARAM_KEY } from '../../../constants/route'

import {
  getRequestEmailMessageRaw,
  getRequestEmailMessages,
  getRequestThreadProfile,
} from './RequestProfileTabEmails.api'

function getErrorResponse(error, fallbackMessage) {
  if (error instanceof Response) {
    return error
  }

  const status = error?.response?.status ?? HTTP_STATUS_INTERNAL_SERVER_ERROR
  const message =
    error?.response?.data?.message ?? error?.message ?? fallbackMessage

  return new Response(message, { status })
}

export async function requestThreadMessageProfilePrintDataLoader({ params }) {
  const { mailUuid, outboundUuid, requestId } = params

  try {
    const [messagesRes, requestRes] = await Promise.all([
      getRequestEmailMessages({
        outboundUuid,
        params: { uuid: [mailUuid] },
        requestId,
      }),
      getRequestProfileBase({ id: requestId, outboundUuid }).catch(error => {
        console.error('Failed to load request profile base:', error)

        return null
      }),
    ])

    const item = messagesRes?.data?.items?.[0]

    if (!item) {
      throw new Response('Message not found', { status: HTTP_STATUS_NOT_FOUND })
    }

    return { ...item, requestNumber: requestRes?.data?.request_no }
  } catch (error) {
    throw getErrorResponse(error, 'Failed to load message data')
  }
}

export async function requestThreadMessageProfileRawDataLoader({ params }) {
  const { mailUuid, outboundUuid, requestId } = params

  try {
    const [messagesRes, rawRes] = await Promise.all([
      getRequestEmailMessages({
        outboundUuid,
        params: { uuid: [mailUuid] },
        requestId,
      }),
      getRequestEmailMessageRaw({ outboundUuid, requestId, uuid: mailUuid }),
    ])

    const item = messagesRes?.data?.items?.[0]
    const rawText = rawRes?.data?.raw_text

    if (!item || !rawText) {
      throw new Response('Message not found', { status: HTTP_STATUS_NOT_FOUND })
    }

    return { ...item, rawText }
  } catch (error) {
    throw getErrorResponse(error, 'Failed to load message raw data')
  }
}

export async function requestThreadProfilePrintDataLoader({ params }) {
  const { mailUuid, outboundUuid, requestId } = params

  try {
    const [threadRes, messagesRes, requestRes] = await Promise.all([
      getRequestThreadProfile({ outboundUuid, requestId, uuid: mailUuid }),
      getRequestEmailMessages({
        outboundUuid,
        params: {
          [PAGE_SIZE_PARAM_KEY]: PAGINATION_ALL_ITEMS_SIZE,
          request_thread_uuid: mailUuid,
        },
        requestId,
      }),
      getRequestProfileBase({ id: requestId, outboundUuid }).catch(error => {
        console.error('Failed to load request profile base:', error)

        return null
      }),
    ])

    const thread = threadRes?.data
    const messages = messagesRes?.data?.items

    if (!thread || !messages) {
      throw new Response('Thread not found', { status: HTTP_STATUS_NOT_FOUND })
    }

    return {
      ...thread,
      messages,
      requestNumber: requestRes?.data?.request_no,
    }
  } catch (error) {
    throw getErrorResponse(error, 'Failed to load thread data')
  }
}
